export default __webpack_public_path__ + "static/media/publish.81475562.svg";